.modalContent {
  display: flex;
  flex-direction: column;
}
